<template>

    <div>

        <lottie-cta-card-delete :active="isActive" v-show="showDelete"></lottie-cta-card-delete>
        <lottie-cta-card-delete-keep-receiving :active="isActive" v-show="showDeleteKeepReceiving"></lottie-cta-card-delete-keep-receiving>
        <lottie-cta-card-keep :active="isActive" v-show="showKeep"></lottie-cta-card-keep>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '../../assets/ENUM'

import LottieCtaCardDelete from '../../components/lottie/LottieCtaCardDelete'
import LottieCtaCardDeleteKeepReceiving from '../../components/lottie/LottieCtaCardDeleteKeepReceiving.vue'
import LottieCtaCardKeep from '../../components/lottie/LottieCtaCardKeep.vue'

export default {

    name: 'animation-cta-card',

    components: {
        LottieCtaCardDelete,
        LottieCtaCardDeleteKeepReceiving,
        LottieCtaCardKeep
    },

    watch: {
        isCardDraging: function (isDraging) {
            if (isDraging) {
                this.delayBeforeAnimation()
            } else {
                this.isActive = false
            }
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'cardDragDirection',
            'isCardDraging'
        ]),

        showDelete() {
            return this.isCardDraging && this.cardDragDirection === ENUM.DIRECTIONS.LEFT
        },

        showDeleteKeepReceiving() {
            return this.isCardDraging && this.cardDragDirection === ENUM.DIRECTIONS.UP
        },

        showKeep() {
            return this.isCardDraging && this.cardDragDirection === ENUM.DIRECTIONS.RIGHT
        }

    },

    data() {
        return {
            isActive: false
        }
    },

    methods: {


        delayBeforeAnimation() {
            setTimeout( () => {
                if (this.isCardDraging) {
                    this.isActive = true
                }
            }, 500)
        }

    }

}
</script>

<style lang="scss" scoped>


</style>
